var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 31.0832C24.0202 31.0832 30.5827 24.5207 30.5827 16.4998C30.5827 8.479 24.0202 1.9165 15.9993 1.9165C7.97852 1.9165 1.41602 8.479 1.41602 16.4998C1.41602 24.5207 7.97852 31.0832 15.9993 31.0832Z",
    stroke: "#27C453",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80273 16.5001L13.9298 20.6272L22.1986 12.373",
    stroke: "#27C453",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMark);
export default __webpack_public_path__ + "static/media/tickMark.024a0a6b1c921165c6214aff4245f22f.svg";
export { ForwardRef as ReactComponent };